<script setup>
defineOptions({
  name: 'CirculairAgreementsContractSelectionModal',
})

import { ref, computed, getCurrentInstance } from 'vue'
import { router } from '@inertiajs/vue3'
import Modal from '@/components/Modal.vue'
import FormRichSelect from '@/components/Form/FormRichSelect.vue'

const instance = getCurrentInstance()
const route = instance?.appContext.config.globalProperties.route

const props = defineProps({
  modelValue: { type: [Boolean, String], default: false },
})

const emit = defineEmits(['update:modelValue', 'select', 'close'])

const show = computed({
  get: () => !!props.modelValue,
  set: (value) => emit('update:modelValue', value),
})

const selectedContract = ref(null)
const searchUrl = computed(() => route('contracts.circulair-agreements.data'))

function handleSelect() {
  if (!selectedContract.value) return

  const contractId = selectedContract.value
  const url = route('contracts.circulair-agreements.step', {
    contract: contractId,
    stepNumber: 1,
    slug: 'materialen',
  })

  emit('select', { contract_id: contractId })
  router.visit(url)
  close()
}

function close() {
  show.value = false
  selectedContract.value = null
  emit('close')
}
</script>

<template>
  <Modal
    :show="show"
    title="CR Afspraken invoeren"
    size="lg"
    theme="green"
    confirm-button-variant="green"
    :confirm-button-disabled="!selectedContract"
    :show-default-footer="true"
    :cancel-button-id="'input-circulair-agreements-modal-cancel'"
    :confirm-button-id="'input-circulair-agreements-modal-select'"
    @close="close"
    @cancel="close"
    @confirm="handleSelect"
  >
    <div class="circulair-agreements-selection-modal-content">
      <p class="modal-description">
        Selecteer een contract om Circulair afspraken in te voeren.
      </p>

      <div class="circulair-agreements-selection-field">
        <label for="input-circulair-agreements-contract-selection" class="form-label">
          Contract
        </label>
        <FormRichSelect
          id="input-circulair-agreements-contract-selection"
          v-model="selectedContract"
          :search-url="searchUrl"
          placeholder="Zoek op titel, klant of opdrachtnemer..."
          option-label="label"
          option-value="value"
          option-layout="card"
          class="wide-dropdown"
        />
      </div>
    </div>
  </Modal>
</template>
